import { uniq, compact, toLower } from 'lodash';
import { selection, timePeriods, raceTypes } from '../../../utils/filter';

const trainerOption = {
    label: 'Trainer',
    value: 'trainer',
};

const jockeyOption = {
    label: 'Jockey',
    value: 'jockey',
};

const getGenericDisplayBy = humanType => compact([
    {
        label: 'Course',
        value: 'course',
    },
    {
        label: 'Distance',
        value: 'distance',
    },
    (humanType === 'jockey' ? trainerOption : jockeyOption),
    {
        label: 'Month',
        value: 'month',
    },
    {
        label: 'Race Class (Handicap, Selling..)',
        value: 'race-type',
    },
    (humanType === 'owner' && trainerOption),
]);

export function displayByFactory(country, type, humanType, selectedValue = null) {
    let options = [];
    const genericDisplayByOptions = getGenericDisplayBy(humanType);

    if (type === 'flat') {
        const year = {
            label: 'Year',
            value: 'year',
        };
        const age = {
            label: 'Age of horse',
            value: 'age-of-horse',
        };
        options = [age, ...genericDisplayByOptions, year];
    } else {
        const raceTypeOption = {
            label: 'Race Type (NHF, Hurdle, Chase)',
            value: 'race-category',
        };
        const season = {
            label: `Season (${country === 'GB' ? 'April' : 'May'} - April)`,
            value: 'season',
        };

        options = [...genericDisplayByOptions, raceTypeOption, season];
    }

    options.find(({ value }) =>
        value === selectedValue || value === 'year' || value === 'season').selected = true;

    return {
        options,
        title: 'display by',
        createdBy: {
            raceType: type,
            humanType,
        },
    };
}

export function timePeriodFactory(country, type, seasonsAvailable) {
    const currentYear = timePeriods.getCurrentSeasonEndYear(type, country);

    const options = [
        timePeriods.getAll(1988, currentYear),
        timePeriods.getCurrent(currentYear, type),
        timePeriods.getLast5(currentYear, type),
        ...timePeriods.getPeriods(currentYear - 1, currentYear - 6, type),
    ];

    options[0].selected = true;

    return {
        options,
        title: 'time period',
        createdBy: {
            raceType: type,
        },
        seasonsAvailable,
    };
}

function getAdvancedOptions(type) {
    if (type === 'flat') {
        return [
            {
                label: '2yo',
                value: '2yo',
            },
            {
                label: '3yo',
                value: '3yo',
            },
            {
                label: '4yo+',
                value: '4yo+',
            },
        ];
    }

    return [
        {
            label: 'Hurdles',
            value: 'hurdle',
        },
        {
            label: 'Chases',
            value: 'chase',
        },
        {
            label: 'National Hunt Flat',
            value: 'nhf',
        },
    ];
}

export function advancedFactory(country, type, displayBy = null, humanType) {
    const noFilter = {
        value: 'overall',
        label: 'No filter',
        selected: true,
    };
    let options = [noFilter];

    if (getGenericDisplayBy(humanType).some(o => o.value === displayBy)) {
        options = [noFilter, ...getAdvancedOptions(type)];
    }

    return {
        options,
        title: `advanced filter (${type === 'jumps' ? 'by code' : 'by age'})`,
        createdBy: {
            raceType: type,
        },
    };
}

export const raceTypeFactory = (country, type) => ({
    title: 'race type',
    options: selection.setSelected(raceTypes.human, `${country}/${type}`),
});

export const categoriesFactory = (country, type, humanType, seasonsAvailable) => {
    const raceType = raceTypeFactory(country, type);
    const displayBy = displayByFactory(country, type, humanType);
    const timePeriod = timePeriodFactory(country, type, seasonsAvailable);
    const advanced = advancedFactory(country, type);
    return { raceType, displayBy, timePeriod, advanced };
};

function getAdvancedStatus(categories) {
    const selectedValue = selection.getValue(categories, 'advanced');
    if (selectedValue !== 'overall') {
        return selection.getCaption(categories, 'advanced');
    }

    return null;
}

function getTimePeriodStatus(categories) {
    const option = selection.getOption(categories, 'timePeriod');
    const years = uniq(option.value.split('/').slice(0, 2));

    if (option.value.match(/last5/)) {
        return toLower(option.label);
    }
    if (option.value.match(/all/)) {
        return years.join(' - ');
    }
    if (years.length > 1) {
        years[1] = years[1].slice(2);
    }
    return years.join('-');
}

export const statusFactory = categories => ({
    raceType: selection.getCaption(categories, 'raceType'),
    displayBy: selection.getCaption(categories, 'displayBy'),
    timePeriod: getTimePeriodStatus(categories),
    advanced: getAdvancedStatus(categories),
});



// WEBPACK FOOTER //
// ./src/js/human/stats/statsTable/categories.js